import is from '@sindresorhus/is';
import { formatDistance } from 'date-fns';
import type { FunctionComponent } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';

export const DateText: FunctionComponent<{ readonly value?: string }> = ({ value }) => {
    const {
        applicationState: { clock, language },
    } = useApplicationContext();

    if (!is.nonEmptyString(value)) return <span>–</span>;

    return (
        <span>
            {formatDistance(new Date(value), clock.getCurrentTimestamp(), {
                addSuffix: true,
                locale: language.date.locale,
            })}
        </span>
    );
};
